// extracted by mini-css-extract-plugin
module.exports = {"edgeLabel":"CustomEdge_edgeLabel__p4H5B"};